
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  SupportTicketMessageDto,
  SupportTicketSystemMessageEnum,
  SupportTicketUploadPermissionDto,
} from '@/services/api-clients';
import { utcToLocalDatetimeFilter } from '@/filters';

@Component({
  filters: { utcToLocalDatetimeFilter },
})
export default class SupportTicketSystemMessageBubble extends Vue {
  @Prop({ type: Object, required: true }) message!: SupportTicketMessageDto;

  get text(): string {
    const actor = (this.message.content ?? '').trim();
    switch (this.message.systemMessageId) {
      case SupportTicketSystemMessageEnum.EmployeeClaimed: return this.$t(this.$LF.SupportSystemMessageEmployeeClaimed, [actor]) as string;
      case SupportTicketSystemMessageEnum.EmployeeTakenOver: return this.$t(this.$LF.SupportSystemMessageEmployeeTakenOver, [actor]) as string;
      case SupportTicketSystemMessageEnum.EmployeeClosed: return this.$t(this.$LF.SupportSystemMessageEmployeeClosed, [actor]) as string;
      case SupportTicketSystemMessageEnum.DriverClosed: return this.$t(this.$LF.SupportSystemMessageDriverClosed) as string;
      case SupportTicketSystemMessageEnum.AutoClosed: return this.$t(this.$LF.SupportSystemMessageAutoClosed) as string;
      case SupportTicketSystemMessageEnum.EmployeeRestored: return this.$t(this.$LF.SupportSystemMessageEmployeeRestored, [actor]) as string;
      case SupportTicketSystemMessageEnum.ActivityCheck: return this.$t(this.$LF.SupportSystemMessageActivityCheck) as string;
      case SupportTicketSystemMessageEnum.UploadPermissionGranted:
        return this.$t(this.$LF.SupportSystemMessageUploadPermissionGranted, [actor, this.permission?.maxFiles]) as string;
      case SupportTicketSystemMessageEnum.UploadPermissionDriverFinished:
        return this.$t(this.$LF.SupportSystemMessageUploadPermissionDriverFinished, [this.permission?.sentFiles, this.permission?.maxFiles]) as string;
      case SupportTicketSystemMessageEnum.UploadPermissionLimitReached:
        return this.$t(this.$LF.SupportSystemMessageUploadPermissionLimitReached, [this.permission?.sentFiles, this.permission?.maxFiles]) as string;
      case SupportTicketSystemMessageEnum.UploadPermissionEmployeeEnded:
        return this.$t(this.$LF.SupportSystemMessageUploadPermissionEmployeeEnded, [actor, this.permission?.sentFiles, this.permission?.maxFiles]) as string;
      case SupportTicketSystemMessageEnum.FileSavedToDriverFiles:
        return this.$t(this.$LF.SupportSystemMessageFileSavedToDriverFiles, [actor, this.message.attachmentFileName]) as string;
      default: return '';
    }
  }

  get icon(): string {
    switch (this.message.systemMessageId) {
      case SupportTicketSystemMessageEnum.EmployeeClaimed: return 'mdi-account-plus-outline';
      case SupportTicketSystemMessageEnum.EmployeeTakenOver: return 'mdi-account-arrow-right-outline';
      case SupportTicketSystemMessageEnum.EmployeeClosed: return 'mdi-check-circle-outline';
      case SupportTicketSystemMessageEnum.DriverClosed: return 'mdi-account-check-outline';
      case SupportTicketSystemMessageEnum.AutoClosed: return 'mdi-clock-outline';
      case SupportTicketSystemMessageEnum.EmployeeRestored: return 'mdi-restore';
      case SupportTicketSystemMessageEnum.ActivityCheck: return 'mdi-account-clock-outline';
      case SupportTicketSystemMessageEnum.UploadPermissionGranted: return 'mdi-paperclip';
      case SupportTicketSystemMessageEnum.UploadPermissionDriverFinished:
      case SupportTicketSystemMessageEnum.UploadPermissionLimitReached:
      case SupportTicketSystemMessageEnum.UploadPermissionEmployeeEnded: return 'mdi-check-circle-outline';
      case SupportTicketSystemMessageEnum.FileSavedToDriverFiles: return 'mdi-folder-account-outline';
      default: return 'mdi-information-outline';
    }
  }

  get permission(): SupportTicketUploadPermissionDto | undefined {
    return this.message.uploadPermission;
  }
}
